import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCurseforgeComponent } from './simple-icons-curseforge.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCurseforgeComponent ],
    exports:      [ SimpleIconsCurseforgeComponent ],
    bootstrap:    []
})
export class SimpleIconsCurseforgeModule {}
